import React, { FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PollingAddress } from "../../../../../models/pollingAddress";
import { getSettings } from "../../../../../services/get.data.service";
import isDuplicate from "../../shared/helpers/isDuplicate";
import SettingsView from "../../shared/settingsView";
import { ResultsTableRowData, SettingsParams, SettingsType } from "../types";
import PollingAddressForm from "./pollingAddressForm";
import { dbDateStringToLocalDate } from "../../../../shared/helpers/dates";

const PollingAddressSettings: FC = () => {
  const { id }: SettingsParams = useParams();
  const [data, setData] = useState<PollingAddress[] | null>([]);

  const loadData = (): void => {
    getSettings<PollingAddress>("emailaccounts").then((response) => {
      setData(response.data);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const rows: ResultsTableRowData[] | null =
    data &&
      data.map((pollingAddress) => {      
      return {
        id: pollingAddress.emailAccountId,
        data: [
          pollingAddress.emailAddress,
          pollingAddress.mailboxFolderName || "Inbox",
          pollingAddress.activelyPolling ? "Yes" : "No",
pollingAddress.activelyPolling &&
            (pollingAddress.group.pollingPaused ||
              (pollingAddress.groupRules?.some((rule) => rule.group.pollingPaused) ?? false)) ?
            <span className="badge badge-pill badge-danger">Yes</span> :
            "No",
          pollingAddress.pollFrom  ? dbDateStringToLocalDate(pollingAddress.pollFrom).toLocaleString() : "-",
          pollingAddress.client?.clientName ? pollingAddress.client?.clientName : "",
          pollingAddress.group.businessName,
          <Link
            key={`list-${pollingAddress.emailAccountId}`}
            to={`/system-settings/emailaccounts/edit/${pollingAddress.emailAccountId}`}
          >
            Edit
          </Link>,
        ],
      };
    });

  return (
    <SettingsView
      headers={["Email", "Folder", "Actively Polling", "Polling Paused", "Polling Emails After", "Client", "Default Group"]}
      rows={rows}
      sortColumn={0}
      titleSingle="Email Account"
      titlePlural="Email Accounts"
      type={SettingsType.emailaccounts}
    >
      {data !== null && (
        <PollingAddressForm
          isDuplicate={(value): boolean => {
            return isDuplicate(data.map((item)=>{
              const folderId = item.mailboxFolderId === null ? "inbox" : item.mailboxFolderId;
              return {id:item.emailAccountId, value: `${item.emailAddress.trim()}|${folderId}`};
            }), value, Number(id));
          }}
          existingPollingAddress={data?.find((pollingAddress) => pollingAddress.emailAccountId === Number(id))}
          load={loadData}
        />
      )}
    </SettingsView>
  );
};
export default PollingAddressSettings;
